import { t } from 'i18next';

export enum SystemClaim {
    AccessSubjectsTab = 'AccessSubjectsTab',
    AccessCoursesTab = 'AccessCoursesTab',
    AccessQuestionsTab = 'AccessQuestionsTab',
    AccessQuestionsBanksTab = 'AccessQuestionsBanksTab',
    AccessExamsTab = 'AccessExamsTab',
    AccessPricingPlansTab = 'AccessPricingPlansTab',
    AccessLicensesTab = 'AccessLicensesTab',
    AccessUsersTab = 'AccessUsersTab',
    AccessRolesTab = 'AccessRolesTab',
    AccessStudentsTab = 'AccessStudentsTab',
    AccessStudentResultsTab = 'AccessStudentResultsTab',
    AccessLiveRoomsTab = 'AccessLiveRoomsTab',
    AccessAttendanceTab = 'AccessAttendanceTab',
    AccessFinancialReportsTab = 'AccessFinancialReportsTab',
    AccessEnrollmentRequestsTab = 'AccessEnrollmentRequestsTab',
    AccessTenantSettingsTab = 'AccessTenantSettingsTab',
    SendParentNotifications = 'SendParentNotifications',
}

export const getSystemClaimLabels = () => ({
    [SystemClaim.AccessSubjectsTab]: t('role.claims.accessSubjectsTab'),
    [SystemClaim.AccessCoursesTab]: t('role.claims.accessCoursesTab'),
    [SystemClaim.AccessQuestionsTab]: t('role.claims.accessQuestionsTab'),
    [SystemClaim.AccessQuestionsBanksTab]: t('role.claims.accessQuestionsBanksTab'),
    [SystemClaim.AccessExamsTab]: t('role.claims.accessExamsTab'),
    [SystemClaim.AccessPricingPlansTab]: t('role.claims.accessPricingPlansTab'),
    [SystemClaim.AccessLicensesTab]: t('role.claims.accessLicensesTab'),
    [SystemClaim.AccessUsersTab]: t('role.claims.accessUsersTab'),
    [SystemClaim.AccessRolesTab]: t('role.claims.accessRolesTab'),
    [SystemClaim.AccessStudentsTab]: t('role.claims.accessStudentsTab'),
    [SystemClaim.AccessStudentResultsTab]: t('role.claims.accessStudentResultsTab'),
    [SystemClaim.AccessLiveRoomsTab]: t('role.claims.accessLiveRoomsTab'),
    [SystemClaim.AccessAttendanceTab]: t('role.claims.accessAttendanceTab'),
    [SystemClaim.AccessFinancialReportsTab]: t('role.claims.accessFinancialReportsTab'),
    [SystemClaim.AccessEnrollmentRequestsTab]: t('role.claims.accessEnrollmentRequestsTab'),
    [SystemClaim.AccessTenantSettingsTab]: t('role.claims.accessTenantSettingsTab'),
    [SystemClaim.SendParentNotifications]: t('role.claims.sendParentNotifications'),
});

export const getSystemClaimLabel = (claim: SystemClaim): string => {
    const labels = getSystemClaimLabels();
    return labels[claim];
};